import type * as React from 'react';
const SvgIcoDash = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8.353 12.35h8" stroke="currentColor" strokeWidth={2} />
  </svg>
);
export default SvgIcoDash;
